export default {
  generating: {
    button: "Generate Media...",
    body: "Your media package is being generated",
    heading: "Generating...",
    done: "Your media package is ready!",
  },
};
